import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { GaContext } from '@/contexts/GaContext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useContext } from 'react';
import { LobbyLayoutContext } from '../../Layout';

const StyledExpandIconButton = styled(IconButton)({
    marginTop: 'auto',
    marginRight: '0',
    justifyContent: 'right',
    width: '6vh',
    height: '6vh',
    padding: 'calc(0.5 * var(--vh))',
    '& .MuiSvgIcon-root': {
        width: '100%',
        height: '100%',
    },
    '&.MuiButtonBase-root:hover': {
        backgroundColor: 'transparent',
    },
});

export const ExpandButton = () => {
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { open, setOpen } = useContext(LobbyLayoutContext);
    const { page } = useContext(GaContext);

    return (
        <StyledExpandIconButton
            disableRipple={true}
            onClick={() => {
                playButtonAudio();
                setOpen(!open);
            }}
            id={
                page ? (open ? `${page}_to-collapse` : `${page}_to-expand`) : ''
            }
        >
            {open ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}
        </StyledExpandIconButton>
    );
};
